import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { get, isEmpty } from 'lodash-es';
import { message } from '@docon/docon-ui-library';
import apis, { IApis } from 'apis/index';
import { storageService } from 'services';
import { logout } from './reducer/logout';

function handleApiError({
  error, message: msg,
  messages = [], errors,
}: any) {

  let errorMsg = msg || error || messages?.join('\n') || '';
  const errorObj = errors;
  if (!isEmpty(errorObj)) {
    errorMsg = Object.keys(errorObj).map((key: string) => `${get(errorObj, `${key}[0]`, '')}`).join('\n');
  }

  if (errorMsg)
    message.error(errorMsg, { autoClose: 1500 });
}

export const createAsyncAction = (type: string, fuName: keyof IApis) => createAsyncThunk<any, any>(
  type,
  async (payload, thunkAPI) => {
    try {
      const response = await apis[fuName](payload);
      const responsePayload = response.data;

      if (fuName === 'logout')
        return responsePayload;

      switch (responsePayload.code) {
        case 400:
        case '400':
          handleApiError(responsePayload);
          return thunkAPI.rejectWithValue(responsePayload);
        case 401:
        case '401':
          {
            if (fuName === 'login') {
              handleApiError(responsePayload);
              return thunkAPI.rejectWithValue(responsePayload);
            } else {
              const token = await storageService.get(storageService.ACCESS_TOKEN);
              thunkAPI.dispatch(logout(token));
            }
            break;
          }
      }

      return responsePayload;
    } catch (error) {
      const err: any = error;
      const errorResponse = err?.response?.data || {};
      const status = err?.response?.status;
      console.log('errorResponse :>> ', errorResponse);

      switch (true) {
        case err.message === 'Network Error':
          message.error(err.message, { autoClose: 1000 });
          break;
        case axios.isCancel(error):
          {
            err.name = 'AbortError';
            throw err;
          }
        case status === 401:
          {
            const token = await storageService.get(storageService.ACCESS_TOKEN);
            thunkAPI.dispatch(logout(token));
            break;
          }
        case status !== 401:
          handleApiError(errorResponse);
          break;
      }

      return thunkAPI.rejectWithValue(errorResponse);
    }
  },
);
